var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrearPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8421 6.94737H10.1053V8.8421H12V10.1053H10.1053V12H8.8421V10.1053H6.94737V8.8421H8.8421V6.94737ZM1.26316 0H10.1053C10.8063 0 11.3684 0.562105 11.3684 1.26316V6.18947C10.9832 5.96842 10.56 5.81053 10.1053 5.73474V1.26316H1.26316V10.1053H5.73474C5.81053 10.56 5.96842 10.9832 6.18947 11.3684H1.26316C0.562105 11.3684 0 10.8063 0 10.1053V1.26316C0 0.562105 0.562105 0 1.26316 0ZM2.52632 2.52632H8.8421V3.78947H2.52632V2.52632ZM2.52632 5.05263H8.8421V5.73474C8.30526 5.82316 7.81263 6.02526 7.37684 6.31579H2.52632V5.05263ZM2.52632 7.57895H5.68421V8.8421H2.52632V7.57895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrearPp);
export default __webpack_public_path__ + "static/media/crearPP.32cc8832ba97f675b699e1e6ce655bdc.svg";
export { ForwardRef as ReactComponent };